import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CLIENT_ROUTES } from "src/utils/constants";
import Home from "src/modules/Home";
import Profile from "src/screens/Profile";
import Record from "src/screens/Record";
import GroupClients from "src/screens/Profile/Groups/ClientsList";
import PaymentMethods from "src/screens/Profile/PaymentMethods";
import EditProfile from "src/screens/Profile/EditProfile";
import MyCalendar from "src/screens/My_Calendar";
import EventDetail from "src/screens/My_Calendar/EventDetail";
import EventLocations from "src/screens/My_Calendar/ScheduleEvent/EventLocations";
import EventType from "src/screens/My_Calendar/ScheduleEvent/EventType";
import EventsList from "src/screens/My_Calendar/ScheduleEvent/EventsList";
import { ScheduleEventContentProvider } from "src/api/context/ScheduleEventContext";
import Accounts from "src/screens/Accounts";
import ShoppingCart from "src/screens/Cart/ShoppingCart";
import Checkout from "src/screens/Cart/Checkout";
import ClientDashboard from "src/screens/ClientDashboard";
import AgreementOverview from "src/screens/SignedAgreement/AgreementOverview";
import AgreementCheckout from "src/screens/SignedAgreement/AgreementCheckout";
import AgreementDocument from "src/screens/SignedAgreement/AgreementDocument";

const ClientRouter: FC = () => {
  return (
    <Routes>
      <Route path={CLIENT_ROUTES.HOME} element={<ClientDashboard />} />
      <Route path={CLIENT_ROUTES.PROFILE} element={<Profile />} />
      <Route path={CLIENT_ROUTES.EDIT_PROFILE} element={<EditProfile />} />

      <Route path={CLIENT_ROUTES.MY_CALENDAR} element={<MyCalendar />} />

      <Route element={<ScheduleEventContentProvider />}>
        <Route path={CLIENT_ROUTES.MY_CALENDAR_ID} element={<EventDetail />} />
        <Route
          path={CLIENT_ROUTES.SCHEDULE_LOCATION}
          element={<EventLocations />}
        />
        <Route path={CLIENT_ROUTES.SCHEDULE_TYPE} element={<EventType />} />
        <Route path={CLIENT_ROUTES.SCHEDULE_EVENTS} element={<EventsList />} />
        <Route
          path={CLIENT_ROUTES.EVENT_SCHEDULE_ID}
          element={<EventDetail />}
        />
        <Route
          path={CLIENT_ROUTES.EVENT_CONFIRMATION_ID}
          element={<EventDetail />}
        />
        <Route path={CLIENT_ROUTES.SHOPPING_CART} element={<ShoppingCart />} />
        <Route path={CLIENT_ROUTES.CHECKOUT} element={<Checkout />} />
      </Route>

      <Route path={CLIENT_ROUTES.MY_ACCOUNTS} element={<Accounts />} />
      <Route path={CLIENT_ROUTES.MY_RECORDS} element={<Record />} />
      <Route
        path={CLIENT_ROUTES.PAYMENT_METHODS}
        element={<PaymentMethods />}
      />
      <Route
        path={`${CLIENT_ROUTES.GROUP_CLIENTS}/:id`}
        element={<GroupClients />}
      />
      <Route
        path={CLIENT_ROUTES.AGREEMENT_OVERVIEW}
        element={<AgreementOverview />}
      />
      <Route
        path={CLIENT_ROUTES.AGREEMENT_DOCUMENT}
        element={<AgreementDocument />}
      />
      <Route
        path={CLIENT_ROUTES.AGREEMENT_CHECKOUT}
        element={<AgreementCheckout />}
      />
      <Route path="/*" element={<Navigate to={CLIENT_ROUTES.HOME} />} />
    </Routes>
  );
};

export default ClientRouter;
